export function useGetAppDataContent<T>(appDataContent: T | undefined) {
  return appDataContent ? (appDataContent as T) : undefined;
}
